import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from './layouts/AppLayout';
import { EventsDebugPage } from './pages/events/EventsDebugPage';
import { ExclusionGroupCreatePage } from './pages/exclusion-groups/ExclusionGroupCreatePage';
import { ExclusionGroupDetailPage } from './pages/exclusion-groups/ExclusionGroupDetailPage';
import { ExclusionGroupListPage } from './pages/exclusion-groups/ExclusionGroupListPage';
import { ExperimentCreatePage } from './pages/experiments/ExperimentCreatePage';
import { ExperimentDetailPage } from './pages/experiments/ExperimentDetailPage';
import { ExperimentListPage } from './pages/experiments/ExperimentListPage';
import { FlagCreatePage } from './pages/flags/FlagCreatePage';
import { FlagDetailPage } from './pages/flags/FlagDetailPage';
import { FlagListPage } from './pages/flags/FlagListPage';
import { ProjectCreatePage } from './pages/projects/ProjectCreatePage';
import { ProjectDetailPage } from './pages/projects/ProjectDetailPage';
import { ProjectListPage } from './pages/projects/ProjectListPage';
import { SubmissionDetailPage } from './pages/submissions/SubmissionDetailPage';
import { SubmissionListPage } from './pages/submissions/SubmissionListPage';

export const router = createBrowserRouter([
	{
		path: '/',
		element: <AppLayout />,
		children: [
			{ index: true, element: <Navigate to="/projects" replace /> },
			{ path: 'projects', element: <ProjectListPage /> },
			{ path: 'projects/new', element: <ProjectCreatePage /> },
			{ path: 'projects/:id', element: <ProjectDetailPage /> },
			{ path: 'projects/:id/experiments', element: <ExperimentListPage /> },
			{ path: 'projects/:id/experiments/new', element: <ExperimentCreatePage /> },
			{ path: 'projects/:id/experiments/:expId', element: <ExperimentDetailPage /> },
			{ path: 'projects/:id/flags', element: <FlagListPage /> },
			{ path: 'projects/:id/flags/new', element: <FlagCreatePage /> },
			{ path: 'projects/:id/flags/:flagId', element: <FlagDetailPage /> },
			{
				path: 'projects/:id/exclusion-groups',
				element: <ExclusionGroupListPage />,
			},
			{
				path: 'projects/:id/exclusion-groups/new',
				element: <ExclusionGroupCreatePage />,
			},
			{
				path: 'projects/:id/exclusion-groups/:groupId',
				element: <ExclusionGroupDetailPage />,
			},
			{ path: 'projects/:id/submissions', element: <SubmissionListPage /> },
			{ path: 'projects/:id/submissions/:subId', element: <SubmissionDetailPage /> },
			{ path: 'projects/:id/events', element: <EventsDebugPage /> },
		],
	},
]);
